import { render, staticRenderFns } from "./OverdueNoticeDialog.vue?vue&type=template&id=68af6386&scoped=true"
import script from "./OverdueNoticeDialog.vue?vue&type=script&lang=js"
export * from "./OverdueNoticeDialog.vue?vue&type=script&lang=js"
import style0 from "./OverdueNoticeDialog.vue?vue&type=style&index=0&id=68af6386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af6386",
  null
  
)

export default component.exports